module.exports = __webpack_public_path__ + "img/fig13.3f1bfedc.jpg";